/**
 * VIOCOM Business Theme – Main JavaScript
 * Version: 1.0.0
 */

'use strict';

// ============================================================
// MOBILE MENU
// ============================================================

(function initMobileMenu() {
  const toggle = document.getElementById('mobile-menu-toggle');
  const menu = document.getElementById('mobile-menu');
  const overlay = document.getElementById('mobile-menu-overlay');

  if (!toggle || !menu) return;

  const header = document.getElementById('site-header');
  if (header) {
    const setHeaderH = () => document.documentElement.style.setProperty('--header-h', header.offsetHeight + 'px');
    setHeaderH();
    if (window.ResizeObserver) new ResizeObserver(setHeaderH).observe(header);
    else window.addEventListener('resize', setHeaderH);
  }

  function openMenu() {
    menu.hidden = false;
    overlay.hidden = false;
    toggle.setAttribute('aria-expanded', 'true');
    toggle.querySelector('.icon-menu').style.display = 'none';
    toggle.querySelector('.icon-close').style.display = 'block';
    document.body.style.overflow = 'hidden';
    const first = menu.querySelector('a, button');
    if (first) first.focus();
  }

  function closeMenu() {
    menu.hidden = true;
    overlay.hidden = true;
    toggle.setAttribute('aria-expanded', 'false');
    toggle.querySelector('.icon-menu').style.display = 'block';
    toggle.querySelector('.icon-close').style.display = 'none';
    document.body.style.overflow = '';
  }

  toggle.addEventListener('click', () => {
    menu.hidden ? openMenu() : closeMenu();
  });

  if (overlay) {
    overlay.addEventListener('click', closeMenu);
  }

  // Sub-menu toggles — separate toggle button, link navigates normally
  menu.querySelectorAll('.mobile-menu__toggle').forEach((toggleBtn) => {
    toggleBtn.addEventListener('click', () => {
      const row = toggleBtn.closest('.mobile-menu__link-row');
      const children = row ? row.nextElementSibling : null;
      const expanded = toggleBtn.getAttribute('aria-expanded') === 'true';
      toggleBtn.setAttribute('aria-expanded', String(!expanded));
      if (children) children.hidden = expanded;
    });
  });

  // Close on ESC
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && !menu.hidden) { closeMenu(); toggle.focus(); return; }
    if (e.key === 'Tab' && !menu.hidden) {
      const items = Array.from(menu.querySelectorAll('a[href], button:not([disabled])')).filter((el) => el.offsetParent !== null);
      items.push(toggle);
      const i = items.indexOf(document.activeElement);
      if (e.shiftKey && (i <= 0)) { e.preventDefault(); items[items.length - 1].focus(); }
      else if (!e.shiftKey && i === items.length - 1) { e.preventDefault(); items[0].focus(); }
    }
  });
})();

// ============================================================
// SEARCH TOGGLE
// ============================================================

(function initSearch() {
  const searchToggle = document.getElementById('search-toggle');
  const searchBar = document.getElementById('search-bar');

  if (!searchToggle || !searchBar) return;

  searchToggle.addEventListener('click', () => {
    const isExpanded = searchToggle.getAttribute('aria-expanded') === 'true';
    searchBar.hidden = isExpanded;
    searchToggle.setAttribute('aria-expanded', String(!isExpanded));
    if (!isExpanded) {
      searchBar.querySelector('input')?.focus();
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && !searchBar.hidden) {
      searchBar.hidden = true;
      searchToggle.setAttribute('aria-expanded', 'false');
      searchToggle.focus();
    }
  });
})();

// ============================================================
// PRODUCT GALLERY
// ============================================================

(function initProductGallery() {
  const mainGallery = document.getElementById('product-gallery-main');
  if (!mainGallery) return;

  const slides = mainGallery.querySelectorAll('.product-gallery__slide');
  const thumbnails = document.querySelectorAll('.product-gallery__thumbnail');

  function showSlide(mediaId) {
    slides.forEach((slide) => {
      slide.classList.toggle('product-gallery__slide--active', slide.dataset.mediaId === mediaId);
    });
    thumbnails.forEach((thumb) => {
      thumb.classList.toggle('product-gallery__thumbnail--active', thumb.dataset.mediaId === mediaId);
    });
  }

  thumbnails.forEach((thumb) => {
    thumb.addEventListener('click', () => showSlide(thumb.dataset.mediaId));
  });
})();

// ============================================================
// PRODUCT TABS
// ============================================================

(function initProductTabs() {
  document.querySelectorAll('.product-tabs').forEach((tabContainer) => {
    const tabs = tabContainer.querySelectorAll('.product-tabs__tab');
    const panels = tabContainer.querySelectorAll('.product-tabs__panel');

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const targetId = tab.getAttribute('aria-controls');

        tabs.forEach((t) => {
          t.classList.remove('product-tabs__tab--active');
          t.setAttribute('aria-selected', 'false');
        });
        panels.forEach((p) => {
          p.classList.remove('product-tabs__panel--active');
          p.hidden = true;
        });

        tab.classList.add('product-tabs__tab--active');
        tab.setAttribute('aria-selected', 'true');
        const panel = document.getElementById(targetId);
        if (panel) {
          panel.classList.add('product-tabs__panel--active');
          panel.hidden = false;
        }
      });
    });
  });
})();

// ============================================================
// PRODUKTSEITE: TABS (ARIA, Pfeiltasten)
// ============================================================

(function initPdpTabs() {
  document.querySelectorAll('.pdp-tabs').forEach((root) => {
    const tabs = Array.from(root.querySelectorAll('[role="tab"]'));
    if (!tabs.length) return;

    function select(tab, focus) {
      tabs.forEach((t) => {
        const on = t === tab;
        t.classList.toggle('pdp-tabs__tab--active', on);
        t.setAttribute('aria-selected', String(on));
        t.tabIndex = on ? 0 : -1;
        const panel = document.getElementById(t.getAttribute('aria-controls'));
        if (panel) panel.hidden = !on;
      });
      if (focus) tab.focus();
    }

    tabs.forEach((tab, i) => {
      tab.addEventListener('click', () => select(tab, false));
      tab.addEventListener('keydown', (e) => {
        let next = null;
        if (e.key === 'ArrowRight') next = tabs[(i + 1) % tabs.length];
        else if (e.key === 'ArrowLeft') next = tabs[(i - 1 + tabs.length) % tabs.length];
        else if (e.key === 'Home') next = tabs[0];
        else if (e.key === 'End') next = tabs[tabs.length - 1];
        if (!next) return;
        e.preventDefault();
        select(next, true);
      });
    });
  });
})();

// ============================================================
// PRODUKTSEITE: GALERIE-PUNKTE (Smartphone-Slider)
// ============================================================

(function initGalleryDots() {
  const main = document.getElementById('product-gallery-main');
  const dotsEl = document.getElementById('product-gallery-dots');
  if (!main || !dotsEl) return;
  const slides = main.querySelectorAll('.product-gallery__slide');
  if (slides.length < 2) return;

  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  const dots = Array.from(slides).map((_, i) => {
    const b = document.createElement('button');
    b.type = 'button';
    b.className = 'product-gallery__dot';
    b.setAttribute('aria-label', 'Bild ' + (i + 1) + ' von ' + slides.length);
    b.addEventListener('click', () => {
      main.scrollTo({ left: i * main.clientWidth, behavior: reduce.matches ? 'auto' : 'smooth' });
    });
    dotsEl.appendChild(b);
    return b;
  });

  function sync() {
    const i = Math.round(main.scrollLeft / (main.clientWidth || 1));
    dots.forEach((d, n) => d.classList.toggle('is-active', n === i));
  }

  let ticking = false;
  main.addEventListener('scroll', () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => { sync(); ticking = false; });
  }, { passive: true });
  sync();
})();

// ============================================================
// COLLECTION FILTER TOGGLES
// ============================================================

(function initFilterToggles() {
  document.querySelectorAll('.collection-filter__toggle').forEach((toggle) => {
    toggle.addEventListener('click', () => {
      const expanded = toggle.getAttribute('aria-expanded') !== 'false';
      toggle.setAttribute('aria-expanded', String(!expanded));
      const optionsId = toggle.getAttribute('aria-controls');
      const options = optionsId ? document.getElementById(optionsId) : null;
      if (options) options.hidden = expanded;
    });
  });

  // Smartphone: Gruppen eingeklappt starten, außer Gruppen mit aktivem Filter
  if (window.matchMedia('(max-width: 640px)').matches) {
    document.querySelectorAll('.collection-filter__toggle:not([data-has-active])').forEach((toggle) => {
      const options = document.getElementById(toggle.getAttribute('aria-controls'));
      toggle.setAttribute('aria-expanded', 'false');
      if (options) options.hidden = true;
    });
  }
})();

// ============================================================
// QUANTITY INPUT
// ============================================================

(function initQuantityInputs() {
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-quantity]');
    if (!btn) return;

    const wrapper = btn.closest('.quantity-input');
    if (!wrapper) return;
    const input = wrapper.querySelector('.quantity-input__field');
    if (!input) return;

    const direction = btn.dataset.quantity;
    const current = parseInt(input.value, 10) || 1;
    const min = parseInt(input.min, 10) || (direction === 'minus' ? 0 : 1);

    if (direction === 'plus') {
      input.value = current + 1;
    } else if (direction === 'minus') {
      input.value = Math.max(min, current - 1);
    }

    input.dispatchEvent(new Event('change', { bubbles: true }));
  });
})();

// ============================================================
// ADD TO CART (Product Card Quick Add)
// ============================================================

(function initQuickAdd() {
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('.product-card__add-btn');
    if (!btn) return;

    const variantId = btn.dataset.variantId;
    if (!variantId) return;

    const originalHtml = btn.innerHTML;
    btn.disabled = true;
    btn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"></polyline></svg>';

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 }),
      });

      if (!response.ok) throw new Error('Add to cart failed');

      await updateCartCount();
      showCartNotification();

    } catch (err) {
      console.error('Quick add error:', err);
    } finally {
      setTimeout(() => {
        btn.disabled = false;
        btn.innerHTML = originalHtml;
      }, 1500);
    }
  });
})();

// ============================================================
// ADD TO CART (Product Page Form)
// ============================================================

(function initProductForm() {
  const form = document.querySelector('[data-type="add-to-cart-form"]');
  if (!form) return;

  form.addEventListener('submit', async (e) => {
    e.preventDefault();

    const submitBtn = form.querySelector('[name="add"]');
    const originalText = submitBtn.innerHTML;

    submitBtn.disabled = true;
    submitBtn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="spin"><path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83"></path></svg> Wird hinzugefügt...';

    try {
      const formData = new FormData(form);
      const sellingPlan = formData.get('selling_plan');
      const payload = {
        id: formData.get('id'),
        quantity: parseInt(formData.get('quantity'), 10) || 1,
      };
      if (sellingPlan) payload.selling_plan = sellingPlan;
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        const err = await response.json();
        throw new Error(err.description || 'Fehler beim Hinzufügen');
      }

      await updateCartCount();
      showCartNotification();

    } catch (err) {
      console.error('Form add error:', err);
      alert(err.message || 'Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.');
    } finally {
      submitBtn.disabled = false;
      submitBtn.innerHTML = originalText;
    }
  });
})();

// ============================================================
// CART COUNT UPDATE
// ============================================================

async function updateCartCount() {
  try {
    const response = await fetch('/cart.js');
    const cart = await response.json();
    const count = cart.item_count;

    document.querySelectorAll('.site-header__cart-count').forEach((el) => {
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
    });

    // Update aria-label
    const cartBtn = document.querySelector('.site-header__cart-btn');
    if (cartBtn) {
      cartBtn.setAttribute('aria-label', `Warenkorb, ${count} Artikel`);
    }
  } catch (err) {
    console.error('Cart count update error:', err);
  }
}

// ============================================================
// CART NOTIFICATION
// ============================================================

function showCartNotification() {
  const notification = document.getElementById('cart-notification');
  if (!notification) return;

  notification.hidden = false;
  notification.focus();

  clearTimeout(notification._timeout);
  notification._timeout = setTimeout(() => {
    notification.hidden = true;
  }, 5000);
}

// ============================================================
// CART QUANTITY + AUTO-SUBMIT (Cart Page)
// ============================================================

var _cartUpdateTimer;
function syncCartGroup(input) {
  var row = input.closest('[data-group]');
  if (!row) return;
  var max = window.cartGroups ? window.cartGroups.GROUP_MAX : 20;
  var min = parseInt(input.min, 10) || 0;
  var qty = Math.min(max, Math.max(min, parseInt(input.value, 10) || 0));
  input.value = qty;
  var rows = document.querySelectorAll('[data-group]');
  for (var i = 0; i < rows.length; i++) {
    if (rows[i].getAttribute('data-group') !== row.getAttribute('data-group')) continue;
    var f = rows[i].querySelector('input[name="updates[]"]');
    if (f) f.value = qty;
  }
}

window.cartQty = function(btn, delta) {
  var wrapper = btn.closest('.quantity-input');
  if (!wrapper) return;
  var input = wrapper.querySelector('input[type="number"]');
  if (!input) return;
  input.value = Math.max(parseInt(input.min, 10) || 0, (parseInt(input.value, 10) || 0) + delta);
  syncCartGroup(input);
  window.scheduleCartUpdate();
};

document.addEventListener('change', function(e) {
  if (e.target.matches && e.target.matches('[data-group] input[name="updates[]"]')) syncCartGroup(e.target);
});

document.addEventListener('click', function(e) {
  var link = e.target.closest && e.target.closest('[data-cart-remove-group]');
  if (!link || !window.cartGroups) return;
  e.preventDefault();
  clearTimeout(_cartUpdateTimer);
  fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
    .then(function(r) { if (!r.ok) throw new Error('cart'); return r.json(); })
    .then(function(cart) {
      var updates = window.cartGroups.groupUpdates(cart.items, link.getAttribute('data-cart-remove-group'), 0);
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ updates: updates }),
      });
    })
    .then(function(r) { if (!r.ok) throw new Error('update'); window.location.reload(); })
    .catch(function() { window.location.href = link.href; });
});

window.scheduleCartUpdate = function() {
  clearTimeout(_cartUpdateTimer);
  _cartUpdateTimer = setTimeout(function() {
    var btn = document.getElementById('cart-update-btn');
    if (btn) btn.click();
  }, 600);
};

// ============================================================
// PRODUCT VARIANT SELECTOR
// ============================================================

(function initVariantSelector() {
  const productJson = document.getElementById('product-json');
  if (!productJson) return;

  let product;
  try {
    product = JSON.parse(productJson.textContent);
  } catch {
    return;
  }

  const variantButtons = document.querySelectorAll('.product-variant-btn');
  const variantIdInput = document.getElementById('product-variant-id');
  const addToCartBtn = document.getElementById('add-to-cart-btn');
  const priceContainer = document.getElementById('product-price');
  const skuEl = document.getElementById('product-sku');
  const eanEl = document.getElementById('product-ean');

  if (!variantButtons.length) return;

  const selectedOptions = {};

  function getMatchingVariant() {
    return product.variants.find((variant) => {
      return variant.options.every((option, i) => {
        return selectedOptions[i + 1] === option;
      });
    });
  }

  function updateUI(variant) {
    if (!variant) return;

    // Update hidden input
    if (variantIdInput) variantIdInput.value = variant.id;

    // Update price: both modes rendered, CSS shows the active one (mirrors snippets/price.liquid).
    const P = window.viocomPrice;
    if (P && priceContainer) {
      const price = variant.price;
      const compareAt = variant.compare_at_price;

      let html = `<div class="price${compareAt > price ? ' price--on-sale' : ''}">`;
      if (compareAt > price) {
        const savings = Math.round(((compareAt - price) / compareAt) * 100);
        html += `<div class="price__compare-row"><s class="price__uvp">UVP ${P.spans(compareAt)}</s><span class="badge badge--sale">−${savings}%</span></div>`;
      }
      html += `<div class="price__main-row"><span class="price__current">${P.spans(price)}</span></div>`;
      html += `<div class="price__sub-row"><span class="price__net-amount">${P.spans(price, { swap: true, pre_net: 'entspricht ', post_net: ' brutto', pre_gross: 'entspricht ', post_gross: ' netto' })}</span></div>`;
      html += '</div>';
      priceContainer.innerHTML = html;
    }

    // Update selling plan prices for percentage/fixed_amount plans (price plans are static)
    const spGroup = document.getElementById('selling-plan-group');
    if (spGroup && P) {
      spGroup.querySelectorAll('.selling-plan-option__price[data-plan-type]').forEach(function(el) {
        const type = el.dataset.planType;
        if (type === 'percentage') {
          const pct = parseFloat(el.dataset.planPct) || 0;
          el.innerHTML = P.spans(Math.round(variant.price * (1 - pct / 100)));
        } else if (type === 'fixed_amount') {
          const discount = parseFloat(el.dataset.planDiscount) || 0;
          el.innerHTML = P.spans(variant.price - discount);
        }
        // type === 'price': fixed price, never changes with variant
      });
    }

    const stickyPrice = document.getElementById('sticky-atc-price');
    if (P && stickyPrice) stickyPrice.innerHTML = P.spans(variant.price);

    document.querySelectorAll('[data-quote-link]').forEach((a) => {
      const url = new URL(a.getAttribute('href'), window.location.origin);
      url.searchParams.set('sku', variant.sku || '');
      a.setAttribute('href', url.pathname + url.search);
    });

    // Update SKU
    if (skuEl) skuEl.textContent = variant.sku || '';
    if (eanEl) {
      eanEl.textContent = variant.barcode || '';
      if (eanEl.parentElement) eanEl.parentElement.hidden = !variant.barcode;
    }

    // Update add to cart button
    if (addToCartBtn) {
      if (variant.available) {
        addToCartBtn.disabled = false;
        addToCartBtn.hidden = false;
        addToCartBtn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"></path><line x1="3" y1="6" x2="21" y2="6"></line><path d="M16 10a4 4 0 0 1-8 0"></path></svg> In den Warenkorb';
      } else {
        addToCartBtn.disabled = true;
        addToCartBtn.hidden = true;
      }
      const inquiryBtn = document.getElementById('add-to-cart-inquiry');
      if (inquiryBtn) inquiryBtn.hidden = !!variant.available;
      const qtyBox = document.querySelector('.product-page__quantity');
      if (qtyBox) qtyBox.hidden = !variant.available;
    }
  }

  variantButtons.forEach((btn) => {
    btn.addEventListener('click', () => {
      const position = parseInt(btn.dataset.variantOption, 10);
      const value = btn.dataset.variantValue;

      selectedOptions[position] = value;

      // Update selected state for this option group
      document.querySelectorAll(`[data-variant-option="${position}"]`).forEach((b) => {
        b.classList.toggle('product-variant-btn--selected', b.dataset.variantValue === value);
      });

      const variant = getMatchingVariant();
      if (variant) updateUI(variant);
    });
  });

  // Initialize with first selected variant
  variantButtons.forEach((btn) => {
    if (btn.classList.contains('product-variant-btn--selected')) {
      const position = parseInt(btn.dataset.variantOption, 10);
      selectedOptions[position] = btn.dataset.variantValue;
    }
  });
})();

// ============================================================
// STICKY HEADER SCROLL BEHAVIOR
// ============================================================

(function initStickyHeader() {
  const header = document.querySelector('.site-header');
  if (!header) return;

  let lastScroll = 0;
  let ticking = false;

  window.addEventListener('scroll', () => {
    if (!ticking) {
      requestAnimationFrame(() => {
        const currentScroll = window.scrollY;
        if (currentScroll > 100 && currentScroll > lastScroll) {
          header.style.transform = 'translateY(-100%)';
        } else {
          header.style.transform = '';
        }
        lastScroll = currentScroll;
        ticking = false;
      });
      ticking = true;
    }
  });
})();

// ============================================================
// PRODUCT GALLERY – TOUCH SWIPE
// ============================================================

(function initGallerySwipe() {
  const mainGallery = document.getElementById('product-gallery-main');
  if (!mainGallery) return;

  let startX = 0;
  let startY = 0;

  mainGallery.addEventListener('touchstart', (e) => {
    startX = e.touches[0].clientX;
    startY = e.touches[0].clientY;
  }, { passive: true });

  mainGallery.addEventListener('touchend', (e) => {
    const dx = startX - e.changedTouches[0].clientX;
    const dy = startY - e.changedTouches[0].clientY;

    // Ignore if mostly a vertical scroll gesture
    if (Math.abs(dy) > Math.abs(dx) || Math.abs(dx) < 40) return;

    const slides = Array.from(mainGallery.querySelectorAll('.product-gallery__slide'));
    const thumbs = Array.from(document.querySelectorAll('.product-gallery__thumbnail'));
    const currentIdx = slides.findIndex((s) => s.classList.contains('product-gallery__slide--active'));
    const nextIdx = dx > 0
      ? Math.min(currentIdx + 1, slides.length - 1)
      : Math.max(currentIdx - 1, 0);

    if (nextIdx === currentIdx) return;

    slides.forEach((s, i) => s.classList.toggle('product-gallery__slide--active', i === nextIdx));
    thumbs.forEach((t, i) => t.classList.toggle('product-gallery__thumbnail--active', i === nextIdx));
  }, { passive: true });
})();

// ============================================================
// MOBILE FILTER SIDEBAR
// ============================================================

(function initMobileFilterSidebar() {
  const sheetQuery = window.matchMedia('(max-width: 1024px)');
  let lastFocus = null;

  const getSidebar = () => document.getElementById('collection-sidebar');
  const getInner = (sb) => sb.querySelector('.collection-sidebar__inner');

  function focusables(root) {
    return Array.from(root.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select, [tabindex]:not([tabindex="-1"])'))
      .filter((el) => el.offsetParent !== null);
  }

  function setOpen(open) {
    const sidebar = getSidebar();
    if (!sidebar) return;
    const btn = document.getElementById('open-filter-sidebar');
    sidebar.classList.toggle('is-open', open);
    if (btn) btn.setAttribute('aria-expanded', String(open));
    document.body.style.overflow = open ? 'hidden' : '';
    if (open) {
      sidebar.removeAttribute('aria-hidden');
      sidebar.setAttribute('role', 'dialog');
      sidebar.setAttribute('aria-modal', 'true');
      sidebar.setAttribute('aria-label', 'Filter');
      lastFocus = document.activeElement;
      const close = document.getElementById('close-sidebar');
      if (close) close.focus();
    } else {
      sidebar.removeAttribute('role');
      sidebar.removeAttribute('aria-modal');
      sidebar.removeAttribute('aria-label');
      if (sheetQuery.matches) sidebar.setAttribute('aria-hidden', 'true');
      if (lastFocus && lastFocus.focus) lastFocus.focus();
      lastFocus = null;
    }
  }

  function syncAriaHidden() {
    const sidebar = getSidebar();
    if (!sidebar) return;
    if (sheetQuery.matches) {
      if (!sidebar.classList.contains('is-open')) sidebar.setAttribute('aria-hidden', 'true');
    } else {
      sidebar.removeAttribute('aria-hidden');
      if (sidebar.classList.contains('is-open')) setOpen(false);
    }
  }

  // Delegiert: der AJAX-Layer tauscht Teile der Seite aus, der Filter-Button darf nicht verwaisen
  document.addEventListener('click', (e) => {
    if (!e.target.closest || !getSidebar()) return;
    if (e.target.closest('#open-filter-sidebar')) setOpen(true);
    else if (e.target.closest('#close-sidebar, #js-sheet-apply, .collection-sidebar__overlay')) setOpen(false);
  });

  document.addEventListener('keydown', (e) => {
    const sidebar = getSidebar();
    if (!sidebar || !sidebar.classList.contains('is-open')) return;
    if (e.key === 'Escape') { setOpen(false); return; }
    if (e.key !== 'Tab') return;
    const items = focusables(getInner(sidebar) || sidebar);
    if (!items.length) return;
    const first = items[0];
    const last = items[items.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  syncAriaHidden();
  sheetQuery.addEventListener('change', syncAriaHidden);
})();

// ============================================================
// COLLECTION SORT (preserves active filter params)
// ============================================================
function updateCollectionSort(value) {
  const url = new URL(window.location.href);
  url.searchParams.set('sort_by', value);
  url.searchParams.delete('page');
  window.location.href = url.toString();
}

// ============================================================
// FILTER "MEHR ANZEIGEN"
// ============================================================
(function initFilterShowMore() {
  document.querySelectorAll('.collection-filter__show-more').forEach((btn) => {
    const list = btn.closest('.collection-filter__options').querySelector('.collection-filter__list');
    if (!list) return;

    btn.addEventListener('click', () => {
      const expanded = btn.getAttribute('aria-expanded') === 'true';
      list.querySelectorAll('.js-filter-extra').forEach((li) => {
        li.hidden = expanded;
      });
      btn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      btn.querySelector('svg').style.transform = expanded ? '' : 'rotate(180deg)';
    });

    // Init: hide extras on load
    list.querySelectorAll('.js-filter-extra').forEach((li) => { li.hidden = true; });
  });
})();

// ============================================================
// SELLING PLANS (Shopify Subscriptions)
// ============================================================
(function () {
  const group = document.getElementById('selling-plan-group');
  if (!group) return;

  const hiddenInput = document.getElementById('selling-plan-input');
  const radios = group.querySelectorAll('input[name="purchase_option"]');
  const labels = group.querySelectorAll('.selling-plan-option');

  function updateSelection(radio) {
    labels.forEach(l => l.classList.remove('selling-plan-option--selected'));
    radio.closest('.selling-plan-option').classList.add('selling-plan-option--selected');
    hiddenInput.value = radio.value === 'onetime' ? '' : radio.value;
  }

  radios.forEach(radio => {
    radio.addEventListener('change', () => updateSelection(radio));
  });

  // Init
  const checked = group.querySelector('input[name="purchase_option"]:checked');
  if (checked) updateSelection(checked);
})();

// ============================================================
// STICKY ADD-TO-CART BAR (Smartphone: fixierte Kaufleiste)
// ============================================================
(function initStickyAtc() {
  const bar = document.getElementById('sticky-atc');
  const mainBtn = document.getElementById('add-to-cart-btn');
  const stickyBtn = document.getElementById('sticky-atc-btn');
  const stickyInquiry = document.getElementById('sticky-atc-inquiry');
  const stickyQtyBox = bar && bar.querySelector('.sticky-atc__qty');
  if (!bar || !mainBtn || !stickyBtn) return;

  function syncButton() {
    const unavailable = mainBtn.disabled;
    stickyBtn.hidden = unavailable;
    if (stickyInquiry) stickyInquiry.hidden = !unavailable;
    if (stickyQtyBox) stickyQtyBox.hidden = unavailable;
  }
  new MutationObserver(syncButton).observe(mainBtn, { attributes: true, attributeFilter: ['disabled'], childList: true, characterData: true, subtree: true });

  // Delegate click to the real submit button so the form handles everything
  stickyBtn.addEventListener('click', function () {
    mainBtn.click();
  });

  // Menge der Leiste und des Formulars gleich halten
  const mainQty = document.getElementById('product-quantity');
  const stickyQty = document.getElementById('sticky-quantity');
  if (mainQty && stickyQty) {
    stickyQty.addEventListener('input', function () { mainQty.value = stickyQty.value; });
    stickyQty.addEventListener('change', function () { mainQty.value = stickyQty.value; });
    mainQty.addEventListener('change', function () { stickyQty.value = mainQty.value; });
  }

  // Leiste ist auf dem Smartphone immer sichtbar (CSS blendet sie sonst aus), aber nie
  // hinter Shopifys Cookie-Banner, der schmaler als der Viewport ist.
  function updateVisibility() {
    var banner = document.getElementById('shopify-pc__banner');
    var bannerOpen = !!banner && getComputedStyle(banner).display !== 'none';
    bar.classList.toggle('is-visible', !bannerOpen);
    bar.setAttribute('aria-hidden', bannerOpen ? 'true' : 'false');
  }
  updateVisibility();

  // Preiszeile der Leiste erst zeigen, wenn die Pricebox aus dem Blick ist (kein doppelter Preis im ersten Screen)
  var pricebox = document.querySelector('.product-page__pricebox');
  if (pricebox && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      bar.classList.toggle('sticky-atc--no-price', entries[entries.length - 1].isIntersecting);
    }).observe(pricebox);
  }

  var banner = document.getElementById('shopify-pc__banner');
  if (banner) {
    new MutationObserver(updateVisibility).observe(banner, {
      attributes: true,
      attributeFilter: ['style'],
    });
  }
})();

// ============================================================
// NETTO/BRUTTO-UMSCHALTER
// ============================================================

(function initPriceToggle() {
  const P = window.viocomPrice;
  if (!P) return;

  function sync() {
    const mode = P.mode();
    document.querySelectorAll('[data-price-mode-set]').forEach((btn) => {
      btn.setAttribute('aria-pressed', String(btn.getAttribute('data-price-mode-set') === mode));
    });
  }

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-price-mode-set]');
    if (!btn) return;
    P.setMode(btn.getAttribute('data-price-mode-set'));
    sync();
  });

  sync();
})();

// ============================================================
// MEGA-PANEL (Produkte, Hersteller, Lösungen)
// ============================================================

document.querySelectorAll('[data-mega-root]').forEach(function initMegaPanel(root) {
  const trigger = root.querySelector('[data-mega-trigger]');
  const panel = root.querySelector('[data-mega-panel]');
  if (!trigger || !panel) return;

  const groups = Array.from(panel.querySelectorAll('[data-mega-group]'));
  const panes = Array.from(panel.querySelectorAll('[data-mega-pane]'));
  const isDesktop = () => window.matchMedia('(min-width: 1025px)').matches;
  const isOpen = () => root.classList.contains('is-open');
  let closeTimer = null;

  function activate(index) {
    groups.forEach((btn, i) => {
      if (i === index) btn.setAttribute('aria-current', 'true');
      else btn.removeAttribute('aria-current');
    });
    panes.forEach((pane, i) => {
      pane.hidden = i !== index;
    });
  }

  function open() {
    window.clearTimeout(closeTimer);
    if (!isDesktop()) return;
    root.classList.add('is-open');
    trigger.setAttribute('aria-expanded', 'true');
  }

  function close(returnFocus) {
    window.clearTimeout(closeTimer);
    if (!isOpen()) return;
    root.classList.remove('is-open');
    trigger.setAttribute('aria-expanded', 'false');
    if (returnFocus) trigger.focus();
  }

  function scheduleClose() {
    window.clearTimeout(closeTimer);
    closeTimer = window.setTimeout(() => close(false), 200);
  }

  trigger.addEventListener('click', () => {
    if (isOpen()) close(false);
    else open();
  });

  trigger.addEventListener('keydown', (e) => {
    if (e.key === 'ArrowDown') {
      e.preventDefault();
      open();
      const firstFocus = groups[0] || panel.querySelector('a');
      if (firstFocus) firstFocus.focus();
    } else if (e.key === 'Escape') {
      close(false);
    }
  });

  root.addEventListener('mouseenter', () => {
    if (isDesktop()) open();
  });
  root.addEventListener('mouseleave', scheduleClose);

  groups.forEach((btn, i) => {
    btn.addEventListener('mouseenter', () => activate(i));
    btn.addEventListener('focus', () => activate(i));
    btn.addEventListener('click', () => activate(i));
    btn.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        groups[(i + 1) % groups.length].focus();
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        groups[(i - 1 + groups.length) % groups.length].focus();
      } else if (e.key === 'ArrowRight') {
        const pane = panes[i];
        const first = pane && (pane.querySelector('.mega-panel__cols a') || pane.querySelector('a'));
        if (first) {
          e.preventDefault();
          first.focus();
        }
      } else if (e.key === 'Home') {
        e.preventDefault();
        groups[0].focus();
      } else if (e.key === 'End') {
        e.preventDefault();
        groups[groups.length - 1].focus();
      }
    });
  });

  panel.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      e.preventDefault();
      close(true);
    }
  });

  root.addEventListener('focusout', (e) => {
    if (!root.contains(e.relatedTarget)) close(false);
  });

  window.addEventListener('resize', () => {
    if (!isDesktop()) close(false);
  });
});
